<div class="access-panel">
  <h4 class="access-panel__title">
    {{ partnerMode ? 'Escopo de Empresas do Parceiro' : 'Escopo de Empresas' }}
  </h4>

  @if (partnerMode) {
    <!--
      Desde o card 2900 (Card A do vínculo Parceiro-Empresa), o escopo de empresas de um
      parceiro deixou de ser por usuário: passou a ser do parceiro inteiro, mantido na tela
      de Gerenciamento › Parceiros. Manter um seletor aqui gravaria vínculo manual num lugar
      que a migration do backend já esvaziou.
    -->
    <p class="access-panel__partner-notice">
      O escopo de empresas de um parceiro é definido em <strong>Comercial › Parceiros</strong>,
      na aba Empresas, e vale para todos os usuários dele.
    </p>
  } @else {
    <p class="access-panel__hint">
      Define quais empresas este usuário poderá acessar ao logar. Apenas um modo pode estar ativo
      por vez.
      @if (!autoSave) {
        <span> O escopo escolhido é salvo junto com o cadastro do usuário.</span>
      }
    </p>

    <app-loading *ngIf="loading()" />

    @if (!loading()) {
      <div class="access-panel__modes">
        <div class="mode-option">
          <label>
            <input type="radio" [(ngModel)]="mode" value="single" />
            Empresa única
          </label>
          @if (mode === 'single') {
            <app-select
              class="mode-option__select"
              [label]="'Empresa'"
              [options]="companyOptions"
              [hasFilter]="true"
              [(ngModel)]="selectedCompanyId" />
          }
        </div>

        <div class="mode-option">
          <label>
            <input type="radio" [(ngModel)]="mode" value="group" />
            Grupo Econômico (vê todas as empresas do grupo)
          </label>
          @if (mode === 'group') {
            <app-select
              class="mode-option__select"
              [label]="'Grupo'"
              [options]="groupOptions"
              [hasFilter]="true"
              [(ngModel)]="selectedGroupId" />
          }
        </div>

        <div class="mode-option">
          <label>
            <input type="radio" [(ngModel)]="mode" value="multi" />
            Múltiplas empresas (seleção livre)
          </label>
          @if (mode === 'multi') {
            <app-select
              class="mode-option__select"
              [label]="'Empresas'"
              [options]="companyOptions"
              [hasFilter]="true"
              [multiple]="true"
              [(ngModel)]="selectedCompanyIds" />
          }
        </div>
      </div>

      @if (autoSave) {
        <div class="access-panel__footer">
          <app-button
            label="Salvar escopo"
            [isLoading]="saving()"
            [loadingText]="'Salvando...'"
            (sendButtonClick)="save()" />
        </div>
      }
    }
  }
</div>
